<template>
	<app>
		<c-form ref="form">
			<c-form-item type="hidden" name="project_id"></c-form-item>
			<c-form-item type="input" label="项目编号" name="code" placeholder="自动生成" required disabled></c-form-item>
			<c-form-item type="input" label="项目名称" name="name" required @change="validName"></c-form-item>
			<c-form-item v-model="currentYzdw" type="select" label="所属业主单位" name="yzdw_id" required options="OWNER_UNIT"></c-form-item>
			<c-form-item type="select" label="所属组织部门" name="yzdw_organization_id" required :options="departmentList"></c-form-item>
			<c-form-item type="select" label="所属行业" name="sshy" required options="INDUSTRY"></c-form-item>
			<c-form-item type="region" label="项目建设地址" province-name="province" city-name="city" county-name="district" address-name="address" required></c-form-item>
			<c-form-item type="file" label="招标文件" name="files_path" required file-type="word,excel,pdf,zip,image"></c-form-item>
			<c-form-item type="radio" label="招标代理费付款方" name="zbdl_money_user_type" required :options="proxyMoneyOptions"></c-form-item>
			<c-form-item type="input" label="业主单位联系人" name="yzdw_lxr"></c-form-item>
			<c-form-item type="input" label="业主单位联系电话" name="yzdw_lxdh"></c-form-item>
			<c-form-item type="textarea" label="备注说明" name="remark"></c-form-item>
		</c-form>
		
		<div slot="button">
			<c-button size="m" @click="submitHandle">确认并提交</c-button>
		</div>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		props: {
			id: String
		},
		
		data() {
			return {
				proxyMoneyOptions: [{
					name: '企业',
					value: 1
				}, {
					name: '业主',
					value: 2
				}],
				currentYzdw: '',
				departmentList: []
			}
		},
		
		watch: {
			currentYzdw(val) {
				this.request({
					url: '/yzdw/organization/selectList',
					data: {
						yzdw_id: val
					},
					success: data => {
						this.departmentList = Array.from(data, item => {
							return {
								name: item.organization_name,
								value: item.organization_id.toString()
							}
						});
						this.$nextTick(() => {
							this.$refs.form.set({
								yzdw_organization_id: ''
							});
						})
					}
				});
			}
		},
		
		mounted() {
			if (this.id) {
				this.request({
					url: '/project/detail',
					data: {
						project_id: this.id
					},
					loading: true,
					success: data => {
						this.$refs.form.set({
							project_id: data.project_info.id
						});
						this.$refs.form.set(data.project_info);
					}
				});
			}
		},
		
		methods: {
			validName(name) {
				this.request({
					url: '/project/existsName',
					data: {
						project_id: 0,
						name
					},
					fail: () => {
						this.$refs.form.set({
							name: ''
						});
					}
				});
			},
			
			submitHandle() {
				this.$refs.form.submit({
					url: this.id ? '/project/update' : '/project/add',
					rule: {
						name: '请填写项目名称',
						yzdw_id: '请选择所属业主单位',
						yzdw_organization_id: '请选择所属组织部门',
						sshy: '请选择所属行业',
						district: '请选择项目建设地址',
						address: '请填写项目建设详细地址',
						files_path: '请上传招标文件',
						zbdl_money_user_type: '请选择招标代理费付款方'
					},
					success: () => {
						this.$message({
							text: '提交成功'
						});
						this.navigateBack();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
